// extracted by mini-css-extract-plugin
export default {"container":"TaxiOrderMsg_container__6CDB4","btn":"TaxiOrderMsg_btn__wBc3R","text":"TaxiOrderMsg_text__zE7Es","title":"TaxiOrderMsg_title__TXpLv"};